







































import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import PaginateModel from "@/model/paginate";
import Admin from "@/model/adminUser";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import AdminEdit from "@/components/admin/adminEdit.vue";
import _cloneDeep from "lodash/cloneDeep";

const adminStore = namespace("Admin");

@Component({
  name: "AdminList",
  components: {
    AdminEdit,
    QSearch,
    QPaginate,
    QTableHeader,
  },
})
export default class adminList extends Vue {
  created() {
    this.$root.$on("fetchAdminList", (query) => {
      this.fetchAdminList(query);
    });
  }
  beforeDestroy() {
    this.$root.$off("fetchAdminList");
  }

  @adminStore.Getter
  public getAdmins!: () => Admin[];

  @adminStore.Getter
  public getPaginate!: () => PaginateModel[];

  @adminStore.Action
  fetchAdminList!: (parameters) => void;

  public editData = {};
  public editDataInit = {};

  public headers = [
    { id: "administrator_code", name: "NO", order: "desc", class: "mb__order" },
    { id: "administrator_name", name: "社内利用者名" },
    { id: "login_id", name: "ログインID" },
    { name: "", class: "mb__w60" },
  ];

  public noData = false;

  async doSearch(query: any) {
    const queryString = query.q ?? "";

    await this.fetchAdminList({
      ...query,
      q: queryString.trim(),
    });

    this.noData = this.getAdmins.length === 0 ? true : false;
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public setEditData(admin): void {
    (this.$refs.adminEdit as AdminEdit).clearErrors();
    this.editData = {};
    this.editDataInit = {};

    if (admin.administrator_code) {
      this.editData = {
        ..._cloneDeep(admin),
        login_password: "••••••••",
      };
      this.editDataInit = _cloneDeep(this.editData)
    }
  }
}
